import {useReducer, useRef} from 'react';

import {reducer} from '@reducers/product/list';

import {useShipping} from '../Context/Shipping';

function Desktop(props) {
	const sliderRef = useRef({});
	const {styles} = props;
	const {filters, updateFilter, shippings} = useShipping();
	const [state, dispatch] = useReducer(reducer, {
		open: props.filters.shipping ? true : false,
	});

	const handelCollapse = () => {
		if (state.open) {
			sliderRef.current.style.height =
				sliderRef.current.parentElement.clientHeight + 'px';
			setTimeout(() => {
				sliderRef.current.style.height = '0px';
				dispatch({
					type: 'SET_DATA',
					data: {open: !state.open},
				});
			}, 10);
		} else {
			sliderRef.current.style.height = 'auto';
			dispatch({
				type: 'SET_DATA',
				data: {open: !state.open},
			});
		}
	};
	const handleSelect = (value, label) => {
		let isExist = filters.find(ft => ft._id === value);
		let newFilter = [];
		if (isExist) {
			newFilter = [...filters.filter(i => i._id !== value)];
		} else {
			newFilter = [...filters, {_id: value, label: label, type: 'shipping'}];
		}
		updateFilter(newFilter);
	};
	return (
		<div className={`${styles.filterListCard}`}>
			<div className={`${styles.cardHeader}`}>
				<span
					className='card-link'
					data-toggle='collapse'
					aria-expanded={state.open}
					onClick={() => handelCollapse()}
				>
					Item can ship to
				</span>
			</div>
			<div ref={sliderRef} className={`collapse ${state.open && 'show'}`}>
				<div className={styles.retailerFilter}>
					<div className={styles.checkList}>
						<ul>
							{shippings.map((sh, i) => (
								<li key={i}>
									<label className='custom-check'>
										{sh.name}
										<input
											type='checkbox'
											checked={
												filters.find(ft => ft._id === sh.value) ? true : false
											}
											onChange={() => handleSelect(sh.value, sh.name)}
										/>
										<span className='checkmark'></span>
									</label>
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
}

function Mobile(props) {
	const {styles} = props;
	const {shippings} = useShipping();
	const [state, dispatch] = useReducer(reducer, {
		open: props.filters.length ? true : false,
		collapseItem: props.filters || [],
	});

	const handleSelect = (value, label) => {
		let isExist = state.collapseItem.find(ft => ft._id === value);
		let newFilter = [];
		if (isExist) {
			newFilter = [...state.collapseItem.filter(i => i._id !== value)];
		} else {
			newFilter = [
				...state.collapseItem,
				{_id: value, label: label, type: 'shipping'},
			];
		}
		props.setFilter(newFilter);
		// updateFilter(newFilter, false);
		dispatch({
			type: 'SET_DATA',
			data: {
				collapseItem: newFilter,
			},
		});
	};
	return (
		<div className={`${styles.filterListCard}`}>
			<div className={`collapse show`}>
				<div className={styles.retailerFilter}>
					<div className={styles.checkList}>
						<ul>
							{shippings.map((sh, i) => (
								<li key={i}>
									<label className='custom-check'>
										{sh.name}
										<input
											type='checkbox'
											checked={
												state.collapseItem.find(ft => ft._id === sh.value)
													? true
													: false
											}
											onChange={() => handleSelect(sh.value, sh.name)}
										/>
										<span className='checkmark'></span>
									</label>
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
}

function Shippings(props) {
	return props.isMobile ? <Mobile {...props} /> : <Desktop {...props} />;
}

export default Shippings;
